var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient, computedFrom, bindable } from "aurelia-framework";
import { Reflection } from "../../../utilities/reflection";
var Quill = require("quill");
var RichTextEditor = /** @class */ (function () {
    function RichTextEditor() {
        var _this = this;
        this._textChangedEvent = 'text-change';
        this.onTextChanged = function () {
            var images = _this._quill.root.getElementsByTagName('img');
            _this.html = _this._quill.root.textContent || images.length > 0 ? _this._quill.root.innerHTML : null;
        };
    }
    Object.defineProperty(RichTextEditor.prototype, "editor", {
        get: function () {
            return this._editor;
        },
        set: function (value) {
            if (value) {
                this._quill = new Quill(value, {
                    modules: {
                        toolbar: [
                            [{ header: [1, 2, false] }],
                            ['bold', 'italic', 'underline'],
                            ['image', 'code-block'],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            [{ list: 'ordered' }, { list: 'bullet' }, 'align'],
                        ]
                    },
                    placeholder: 'Write here...',
                    theme: 'snow' // or 'bubble'
                });
                if (this.html) {
                    this._quill.root.innerHTML = this.html;
                }
                this._quill.on(this._textChangedEvent, this.onTextChanged);
            }
            else {
                if (this._quill) {
                    this._quill.off(this._textChangedEvent, this.onTextChanged);
                }
            }
            this._editor = value;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], RichTextEditor.prototype, "html", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._editor; })),
        __metadata("design:type", HTMLDivElement),
        __metadata("design:paramtypes", [HTMLDivElement])
    ], RichTextEditor.prototype, "editor", null);
    RichTextEditor = __decorate([
        autoinject,
        transient()
    ], RichTextEditor);
    return RichTextEditor;
}());
export { RichTextEditor };
